// import { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Box from "@mui/material/Box";
// import Card from "@mui/material/Card";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepLabel from "@mui/material/StepLabel";
// import Typography from "@mui/material/Typography";
// import Paper from "@mui/material/Paper";

// import DeviceReports from "./DeviceReports";
// import SiteReports from "./SiteReports";
// import UserReports from "./UserReports";
// import AlarmReports from "./AlarmReports";
// import AllReports from "./AllReports";
// import TankLevelReports from "./TankLevelReports";
// import DeviceParameterReports from "./DeviceParameterReports";
// import ActiveAlarmReport from "./ActiveAlarmReport";
// import EmailLogsReport from "./EmailLogsReport";


// const steps = [
//   // "Device Reports",
//   // "Site Reports",
//   // "User Reports",
//   "All Reports",
//   "Alarm Reports",
//   "Tank Level Reports",
//   "Device Parameter Reports",
//   "Active/Cleared Alarm Reports",
//   "EmailLogsReport"
// ];

// export default function Reports() {
//   const [activeStep, setActiveStep] = useState(0);

//   const renderStepContent = (step) => {
//     switch (step) {
//       // case 0:
//       //   return <DeviceReports />;
//       // case 1:
//       //   return <SiteReports />;
//       // case 2:
//       //   return <UserReports />;
//       // case 3:
//       //   return <AlarmReports />;
//       case 0 :
//            return <AllReports/>
//       case 1:
//            return <AlarmReports/>
//       case 2:
//            return <TankLevelReports/>
//       case 3:
//            return <DeviceParameterReports/>
//       case 4:
//            return <ActiveAlarmReport/>
//       case 5:
//            return <EmailLogsReport/>

//       default:
//         return null;
//     }
//   };

//   return (
//     <Box sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}>
//       <Typography
//         variant="h5"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           borderBottom: "2px solid #1976d2",
//           display: "inline-block",
//         }}
//       >
//         Reports Dashboard
//       </Typography>

//       {/* Stepper */}
//       <Card sx={{ p: 1, mb: 2, borderRadius: 3, boxShadow: 4 }}>
//         <Stepper activeStep={activeStep} alternativeLabel nonLinear>
//           {steps.map((label, index) => (
//             <Step key={label}>
//               <StepLabel
//                 onClick={() => setActiveStep(index)}
//                 StepIconProps={{
//                   sx: {
//                     cursor: "pointer",
//                     color: "grey.400",
//                     "&.Mui-active": {
//                       color: "#EE7F1A",
//                       transform: "scale(1.3)",
//                     },
//                     "&.Mui-completed": {
//                       color: "#EE7F1A",
//                     },
//                   },
//                 }}
//               >
//                 {label}
//               </StepLabel>
//             </Step>
//           ))}
//         </Stepper>
//       </Card>

//       {/* Content */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={activeStep}
//           initial={{ opacity: 0, x: 50 }}
//           animate={{ opacity: 1, x: 0 }}
//           exit={{ opacity: 0, x: -50 }}
//           transition={{ duration: 0.4 }}
//         >
//           <Paper
//             elevation={6}
//             sx={{
//               p: 2,
//               borderRadius: 3,
//               minHeight: 400,
//               background:
//                 "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)",
//             }}
//           >
//             {renderStepContent(activeStep)}
//           </Paper>
//         </motion.div>
//       </AnimatePresence>
//     </Box>
//   );
// }



import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import DeviceReports from "./DeviceReports";
import SiteReports from "./SiteReports";
import UserReports from "./UserReports";
import AlarmReports from "./AlarmReports";
import AllReports from "./AllReports";
import TankLevelReports from "./TankLevelReports";
import DeviceParameterReports from "./DeviceParameterReports";
import ActiveAlarmReport from "./ActiveAlarmReport";
import EmailLogsReport from "./EmailLogsReport";


const steps = [
  // "Device Reports",
  // "Site Reports",
  // "User Reports",
  "All Reports",
  "Alarm Reports",
  "Tank Level Reports",
  "Device Parameter Reports",
  "Active/Cleared Alarm Reports",
  "EmailLogsReport"
];

export default function Reports() {
  const [activeStep, setActiveStep] = useState(0);

  const renderStepContent = (step) => {
    switch (step) {
      // case 0:
      //   return <DeviceReports />;
      // case 1:
      //   return <SiteReports />;
      // case 2:
      //   return <UserReports />;
      // case 3:
      //   return <AlarmReports />;
      case 0 :
           return <AllReports/>
      case 1:
           return <AlarmReports/>
      case 2:
           return <TankLevelReports/>
      case 3:
           return <DeviceParameterReports/>
      case 4:
           return <ActiveAlarmReport/>
      case 5:
           return <EmailLogsReport/>

      default:
        return null;
    }
  };

  return (
    <Box sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: "bold",
          borderBottom: "2px solid #1976d2",
          display: "inline-block",
        }}
      >
        Reports Dashboard
      </Typography>

      {/* Stepper */}
      <Card sx={{ p: 1, mb: 2, borderRadius: 3, boxShadow: 4 , overflowX: "auto",whiteSpace: "nowrap" }}>
          <Box
    sx={{
      minWidth: "max-content",  // 👈 keeps steps in one line
    }}
  >
        <Stepper activeStep={activeStep} alternativeLabel nonLinear
         sx={{
        flexWrap: "nowrap",    
      }}>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                onClick={() => setActiveStep(index)}
                StepIconProps={{
                  sx: {
                    cursor: "pointer",
                    color: "grey.400",
                    "&.Mui-active": {
                      color: "#EE7F1A",
                      transform: "scale(1.3)",
                    },
                    "&.Mui-completed": {
                      color: "#EE7F1A",
                    },
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        </Box>
      </Card>

      {/* Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeStep}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.4 }}
        >
          <Paper
            elevation={6}
            sx={{
              p: 2,
              borderRadius: 3,
              minHeight: 400,
              background:
                "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)",
            }}
          >
            {renderStepContent(activeStep)}
          </Paper>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
}